// Compilé par Rollup vers assets/built/ (voir package.json).
import "../css/index.css";

import mode from "./mode";
import nav from "./nav";
import alerte from "./alerte";
import rdv from "./rdv";
import agenda from "./agenda";
import mairie from "./mairie";
import article from "./article";
import template from "./template";
import recherche from "./recherche";
import diapo from "./diapo";
import lecteurPdf from "./lecteur-pdf";
import planches from "./planches";

mode();
nav();
alerte();
rdv();
agenda();
mairie();
article();
template();
recherche();
diapo();
lecteurPdf();
planches();
